import onboardingStayFocused from '@/src/renderer/assets/images/onboardingStayFocused.png'
import onboardingStayFocused2x from '@/src/renderer/assets/images/onboardingStayFocused@2x.png'

/**
 * OnboardingStayFocusedIcon Component
 *
 * Displays the meditation person icon for the first onboarding slide.
 * Supports retina displays with @2x image asset.
 *
 * @example
 * <OnboardingStayFocusedIcon />
 */
export const OnboardingStayFocusedIcon = () => {
  return (
    <img
      src={onboardingStayFocused}
      srcSet={`${onboardingStayFocused} 1x, ${onboardingStayFocused2x} 2x`}
      alt="Stay focused - meditation person"
      className="onboarding-icon"
      width={148}
      height={148}
    />
  )
}
